export const calculateDifferenceInDays = (fromNowDate) => {
  const now = new Date();
  const fromNow = new Date(fromNowDate);
  const differenceInTime = fromNow.getTime() - now.getTime();
  const differenceInDays = differenceInTime / (1000 * 3600 * 24);
  return Math.trunc(differenceInDays);
};
